import { Zoom } from "./Zoom.js";
export var ACTION_ZOOM_IN = "zoom-in";
export var ACTION_ZOOM_OUT = "zoom-out";
export default Zoom;